<template>
    <div class="row">
        <div class="col-10">
            <brick-settings-property :label="resource('JourneyComposer_BrickSettingsAudienceFilter_ConditionFieldType_DisplayName')">
                <template v-slot="{id}">
                    <v-select
                        class="form-control"
                        v-model="typeModel"

                        :id="id"
                        :options="fieldTypes"
                        :clearable="false"
                        :disabled="!canWrite || !fieldTypes.length"
                    />
                </template>
            </brick-settings-property>
        </div>
        <div class="col-2">
            <button class="btn btn-outline-danger w-100" @click="$emit('delete')">
                <i class="fas fa-minus"></i>
            </button>
        </div>
        <div class="col-10">
            <brick-settings-property :label="resource('JourneyComposer_BrickSettingsAudienceFilter_ConditionFieldValue_DisplayName')">
                <template v-slot="{id}">
                    <input v-if="!typeIsAudience"
                        :key="id"

                        type="text"
                        class="form-control"
                        :id="id"
                        v-model="valueModel"
                    />
                    <v-select v-else
                        class="form-control"
                        v-model="audienceModel"
                        label="name"

                        :key="id"
                        :id="id"
                        :options="audiences"
                        
                        :disabled="!canWrite || noAudiences"
                        searchable
                        filterable
                    />
                </template>
            </brick-settings-property>
        </div>
    </div>
</template>

<script>
    import resourceMixin from "../../../../../../Util/Mixins/resources";
    import permissionsMixin from '../../../../Mixins/journey-permissions';

    import VSelect from 'vue-select';
    import BrickSettingsProperty from "../BrickSettingsProperty.vue";

    const audienceTypes = ['Audience', 'NotAudience'];

    export default {
        name: 'audience-filter-brick-condition-field',
        mixins: [resourceMixin, permissionsMixin],
        components: {
            VSelect, 
            BrickSettingsProperty
        },
        watch: {
            typeIsAudience(){
                //When our type is 'Audience', our valueModel will contain
                //a value (GUID) from a backing SelectList
                //the value has no use for anything but audiences
                //nor do we want audiences to 'accidentally' receive a value previously
                //entered by the user, therefor we should clear on audience/other type change
                this.valueModel = undefined;
            }
        },
        computed: {
            typeModel: {
                get() {
                    const vm = this;
                    return vm.fieldTypes.find(t => t.key === vm.type);
                },
                set(field){
                    this.$emit('update:type', field ? field.key : undefined);
                }
            },
            valueModel: {
                get(){
                    return this.value;
                },
                set(value){
                    this.$emit('update:value', value);
                }
            },
            typeIsAudience() {
                return audienceTypes.indexOf(this.type) !== -1;
            },
            noAudiences() {
                return this.audiences.length === 0;
            },
            audienceModel: {
                get() {
                    return this.audiences.find((audience) => audience.id === this.value) || null;
                },
                set(value) {
                    this.$emit('update:value', value.id);
                }
            }
        },
        props: {
            type: String,
            value: String,
            
            //[ key: '...', label: '...' ]
            fieldTypes: {
                type: Array,
                required: true
            },
            audiences: {
                type: Array,
                required: true
            }
        }
    }
</script>